import * as Types from './machineParameterActionTypes.js'

const initialState = {
    rpmPump: [{ lineNumber: 11, rpmPump: 0 }, { lineNumber: 12, rpmPump: 0 }],
    speed: [{ lineNumber: 11, speed: 0 }, { lineNumber: 12, speed: 0 }]
};

export default function machineParameter(state = initialState, action) {
    switch (action.type) {
        case Types.SET_RPMPUMP:
            if (state.rpmPump !== action.rpmPump) {
                return Object.assign({}, state, { rpmPump: action.rpmPump });
            }
            return state;
        case Types.SET_SPEED:
            if (state.speed !== action.speed) {
                return Object.assign({}, state, { speed: action.speed });
            }
            // console.log("SET_SPEED, new state without update");
            // console.log(state.speed)
            return state;

        default:
            return state;
    }
}